<template>
  <div>
    <el-dialog title="Historico" :visible.sync="dialog.history" :close-on-click-modal="false">
      <el-table :data="history" stripe style="width: 100%">
        <el-table-column sortable prop="descricao_status" :label="$t('status')"></el-table-column>
        <el-table-column sortable prop="data_atualizacao" :label="$t('data')">
          <template slot-scope="scope">
            {{ scope.row.data_atualizacao.replace("-", "/").replace("-", "/") }}&nbsp;{{ scope.row.hora_atualizacao }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialog.history = false">OK</el-button>
      </span>
    </el-dialog>

    <ReverseLogisticsDetail :id="record.id" :dialog="dialog.detail" v-on:close="close()" />

    <el-dialog title="Dados do objeto" :visible.sync="dialog.object" :close-on-click-modal="false">
      <el-form>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item label="Etiqueta">
              <el-input disabled :value="object.numero_etiqueta"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
            <el-form-item label="Data">
              <el-input
                disabled
                :value="
                  object.data_ultima_atualizacao.replace('-', '/').replace('-', '/') +
                  ' ' +
                  object.hora_ultima_atualizacao
                "
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-form-item label="Peso Cubido">
              <el-input disabled :value="object.peso_cubico" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-form-item label="Peso Real">
              <el-input disabled :value="object.peso_real" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="5" :xl="5">
            <el-form-item label="Valor">
              <el-input disabled :value="object.valor_postagem" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialog.object = false">OK</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="Filtro de Postagem"
      :visible.sync="dialog.filter"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="50%"
      :wrapperClosable="false"
      :append-to-body="true"
      :modal-append-to-body="false"
      :modal="true"
    >
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Postada">
                <el-radio-group v-model="filter.posted">
                  <el-radio label="1">Sim</el-radio>
                  <el-radio label="0">Não</el-radio>
                  <el-radio label="2">Ambos</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Registros">
                <el-select v-model="filter.records">
                  <el-option-group :key="50" label="Registros por página">
                    <el-option :key="50" :label="50" :value="50"></el-option>
                    <el-option :key="100" :label="100" :value="100"></el-option>
                    <el-option :key="150" :label="150" :value="150"></el-option>
                    <el-option :key="200" :label="200" :value="200"></el-option>
                    <el-option :key="250" :label="250" :value="250"></el-option>
                    <el-option :key="300" :label="300" :value="300"></el-option>
                    <el-option :key="350" :label="350" :value="350"></el-option>
                    <el-option :key="400" :label="400" :value="400"></el-option>
                    <el-option :key="450" :label="450" :value="450"></el-option>
                    <el-option :key="500" :label="500" :value="500"></el-option>
                    <el-option :key="1000" :label="1000" :value="1000"></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Etiqueta">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Autorização">
                <el-input v-model="filter.authorization" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Nome">
                <el-input v-model="filter.word" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="CEP">
                <el-input v-model="filter.zipcode" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Estado">
                <el-select v-model="filter.state" filterable>
                  <el-option key="" label="Todos" value=""></el-option>
                  <el-option key="AC" label="Acre" value="AC"></el-option>
                  <el-option key="AL" label="Alagoas" value="AL"></el-option>
                  <el-option key="AP" label="Amapá" value="AP"></el-option>
                  <el-option key="AM" label="Amazonas" value="AM"></el-option>
                  <el-option key="BA" label="Bahia" value="BA"></el-option>
                  <el-option key="CE" label="Ceará" value="CE"></el-option>
                  <el-option key="DF" label="Distrito Federal" value="DF"></el-option>
                  <el-option key="ES" label="Espírito Santo" value="ES"></el-option>
                  <el-option key="GO" label="Goiás" value="GO"></el-option>
                  <el-option key="MA" label="Maranhão" value="MA"></el-option>
                  <el-option key="MT" label="Mato Grosso" value="MT"></el-option>
                  <el-option key="MS" label="Mato Grosso do Sul" value="MS"></el-option>
                  <el-option key="MG" label="Minas Gerais" value="MG"></el-option>
                  <el-option key="PA" label="Pará" value="PA"></el-option>
                  <el-option key="PB" label="Paraíba" value="PB"></el-option>
                  <el-option key="PR" label="Paraná" value="PR"></el-option>
                  <el-option key="PE" label="Pernambuco" value="PE"></el-option>
                  <el-option key="PI" label="Piauí" value="PI"></el-option>
                  <el-option key="RJ" label="Rio de Janeiro" value="RJ"></el-option>
                  <el-option key="RN" label="Rio Grande do Norte" value="RN"></el-option>
                  <el-option key="RS" label="Rio Grande do Sul" value="RS"></el-option>
                  <el-option key="RO" label="Rondônia" value="RO"></el-option>
                  <el-option key="RR" label="Roraima" value="RR"></el-option>
                  <el-option key="SC" label="Santa Catarina" value="SC"></el-option>
                  <el-option key="SP" label="São Paulo" value="SP"></el-option>
                  <el-option key="SE" label="Sergipe" value="SE"></el-option>
                  <el-option key="TO" label="Tocantins" value="TO"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <br />
        <div class="demo-drawer__footer">
          <el-button @click="dialog.filter = false">Cancelar</el-button>
          <el-button
            type="info"
            @click="
              $refs.drawer.closeDrawer();
              clear();
            "
            >Limpar filtros</el-button
          >
          <el-button
            type="primary"
            @click="
              $refs.drawer.closeDrawer();
              fetchRecords();
            "
            >Filtrar</el-button
          >
        </div>
      </div>
    </el-drawer>

    <el-card>
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("logistica-reversa") }} <small>({{ total }} registros)</small>
        </el-col>
        <el-col :offset="4" :lg="12">
          <el-button class="right" type="primary" icon="el-icon-plus" @click="add()">{{ $t("adicionar") }}</el-button>
          <el-pagination
            class="right"
            :page-size="filter.records"
            background
            @current-change="fetchRecords"
            @size-change="changeSize"
            :current-page.sync="filter.page"
            layout="sizes, prev, pager, next"
            :page-sizes="[50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000]"
            :total="total"
          ></el-pagination>
        </el-col>
      </div>
      <el-card shadow="hover">
        <el-form :model="ruleForm" :inline="true" ref="ruleForm">
          <el-row :gutter="5">
            <el-col :span="20">
              <el-form-item :label="$t('periodo')" prop="name">
                <el-date-picker
                  v-model="ruleForm.range"
                  type="daterange"
                  align="right"
                  unlink-panels
                  clearable
                  range-separator="à"
                  format="dd/MM/yyyy"
                  start-placeholder="Inicio"
                  end-placeholder="Fim"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('cliente')" prop="name" v-if="user.type !== '2' && user.type !== '5'">
                <CustomerList v-model="ruleForm.customer" v-bind:multiple="true" />
              </el-form-item>
              <el-form-item class="no-margin-bottom" :label="$t('servico')">
                <ReverseLogisticsList v-model="ruleForm.service" />
              </el-form-item>
              <el-button type="info" style="float: right" size="mini" @click="fetchRecords()">Filtrar</el-button>
            </el-col>
            <el-col :span="3" style="float: right" :offset="1">
              <el-badge is-dot :hidden="hasfilter">
                <el-button size="mini" @click="dialog.filter = true">Mais filtros</el-button>
              </el-badge>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-table
        :data="tableData"
        stripe
        size="mini"
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="companyname"
          v-if="user.type !== '5'"
          :label="user.type === '2' ? $t('filial') : $t('cliente')"
        ></el-table-column>
        <el-table-column sortable prop="contact" :label="$t('contato')"></el-table-column>
        <el-table-column sortable prop="sourcezipcode" :label="$t('origem')"></el-table-column>
        <el-table-column prop="sourcecity" :label="$t('cidade')" sortable>
          <template slot-scope="scope"> {{ scope.row.sourcecity }}/{{ scope.row.sourcestate }} </template>
        </el-table-column>
        <el-table-column sortable prop="destinyzipcode" :label="$t('destino')"></el-table-column>
        <el-table-column prop="destinycity" :label="$t('cidade')" sortable>
          <template slot-scope="scope"> {{ scope.row.destinycity }}/{{ scope.row.destinystate }} </template>
        </el-table-column>
        <el-table-column prop="tag" :label="$t('objeto')" sortable>
          <template slot-scope="scope">{{ scope.row.tag }}</template>
        </el-table-column>
        <el-table-column prop="postedAt" :label="$t('data')" sortable>
          <template slot-scope="scope">{{ scope.row.postedAt }}</template>
        </el-table-column>
        <el-table-column label="#" width="240">
          <template slot="header">#</template>
          <template slot-scope="scope">
            <el-button
              type="primary"
              title="Histórico"
              v-if="scope.row.authorization"
              icon="el-icon-notebook-2"
              @click="openhistory(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="primary"
              v-if="scope.row.authorization"
              icon="el-icon-tickets"
              @click="openobject(scope.row.id)"
              circle
            ></el-button>
            <el-button type="default" icon="el-icon-document" @click="detail(scope.row.id)" circle></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.tag)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix" v-if="!tableData">
        <el-row :gutter="5">
          <el-col :lg="8">
            <el-pagination
              :page-size="filter.records"
              background
              @current-change="fetchRecords"
              :current-page.sync="filter.page"
              layout="prev, pager, next"
              :total="total"
              v-show="total > filter.records"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
      <br />
      <div class="bottom clearfix">
        <el-form :inline="true" ref="ruleForm">
          <el-row :gutter="5">
            <el-col :lg="8" style="margin-top: 2px; float: right">
              <el-dropdown>
                <el-button>
                  Exportar
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><span @click="doexport('csv')">CSV</span></el-dropdown-item>
                  <el-dropdown-item><span @click="doexport('xls')">XLS</span></el-dropdown-item>
                  <el-dropdown-item><span @click="doexport('html')">HTML</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { ReverseLogisticsService } from "@/services/customers/reverse.logistics.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import ReverseLogisticsDetail from "@/xpost/views/services/reverse.logistics/ReverseLogisticsDetail.vue";
import moment from "moment";
import "moment/locale/pt-br";
import ReverseLogisticsList from "./ReverseLogisticsList";
import { PrepostService } from "@/services/customers/prepost.services";

export default {
  name: "ReverseLogistics",
  components: {
    ReverseLogisticsDetail,
    ReverseLogisticsList,
    CustomerList,
    ServicesList,
  },
  computed: {
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.zipcode ||
        vm.filter.state ||
        vm.filter.name ||
        vm.filter.posted !== "2" ||
        vm.filter.authorization ||
        vm.filter.word
      );
    },
  },
  methods: {
    add() {
      var vm = this;
      if (this.$route.params.id) {
        vm.$router.replace({
          name: "reverse.logistics.add.tag",
          params: { tag: this.$route.params.id },
        });
      } else {
        vm.$router.replace({
          name: "reverse.logistics.add",
        });
      }
    },
    openhistory(id) {
      const vm = this;
      vm.history = [];
      const loading = vm.$loading(vm.$options.loading);
      ReverseLogisticsService.authorization(id)
        .then((response) => {
          vm.history = response.history;
          vm.dialog.history = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            duration: 5000,
            message: "Autorização ainda sem histórico!",
          });
        })
        .finally(() => loading.close());
    },
    openobject(id) {
      const vm = this;
      vm.history = [];
      const loading = vm.$loading(vm.$options.loading);
      ReverseLogisticsService.authorization(id)
        .then((response) => {
          vm.object = response.object;
          vm.object.valor_postagem = +response.priceTable;
          vm.dialog.object = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            duration: 5000,
            message: "Autorização ainda não gerou um objeto de postagem!",
          });
        })
        .finally(() => loading.close());
    },
    doexport(type) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      vm.filter.action = "export";
      vm.filter.fileType = type;

      ReverseLogisticsService.list({
        customer: vm.ruleForm.customer,
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD"),
        service: vm.ruleForm.service,
        filter: vm.filter,
      })
        .then((response) => {
          this.$message({
            type: "warning",
            message:
              "Seu relatório de reversas está sendo gerado, assim que terminar você receberá uma notificação no canto superior direito!",
            duration: 5000,
          });
          vm.$bus.$emit("notifications", response.id);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      vm.filter.action = "";
      vm.filter.fileType = "";

      ReverseLogisticsService.list({
        customer: vm.ruleForm.customer,
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD"),
        service: vm.ruleForm.service,
        filter: vm.filter,
      })
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          vm.$notify.error({
            duration: 5000,
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-logistica-reversa", { id: name }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PrepostService.delete(id)
          .then((response) => {
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id === id),
              1
            );
            this.$message({
              type: "success",
              duration: 5000,
              message: i18n.tc("logistica-reversa-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    detail(id) {
      const vm = this;
      const record = vm.tableData.find((x) => x.id == id);
      if (record) {
        vm.record = record;
        vm.dialog.detail = true;
      }
    },
    changeSize(size) {
      const vm = this;
      vm.filter.records = size;
      vm.fetchRecords();
    },
    close() {
      const vm = this;
      vm.dialog.detail = false;
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (response.type == "2") {
          vm.ruleForm.customer.push(response.customers.id);
        }
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      history: [],
      total: 0,
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 10), new Date()],
        customer: [],
        service: "",
      },
      user: {
        type: "2",
      },
      record: {
        tag: "",
      },
      object: {
        data_ultima_atualizacao: "",
      },
      dialog: {
        history: false,
        object: false,
        detail: false,
        filter: false,
      },
      filter: {
        tag: "",
        posted: "2",
        zipcode: "",
        state: "",
        name: "",
        authorization: "",
        records: 50,
        page: 1,
        word: "",
      },
      tableData: [],
    };
  },
};
</script>
